var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5C13.1066 12.5 15.625 10.0748 15.625 7.08329C15.625 4.09175 13.1066 1.66663 10 1.66663C6.8934 1.66663 4.375 4.09175 4.375 7.08329C4.375 10.0748 6.8934 12.5 10 12.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26662 11.2667L6.2583 17.4167C6.2583 18.1667 6.7833 18.5334 7.4333 18.225L9.66663 17.1667C9.84996 17.075 10.1583 17.075 10.3416 17.1667L12.5833 18.225C13.225 18.525 13.7583 18.1667 13.7583 17.4167V11.1167",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand);
export default __webpack_public_path__ + "static/media/brand.b663744802a54b28cadf2b5e7ee76665.svg";
export { ForwardRef as ReactComponent };